import api from ".";

export const acceptUser = async (userId: string) => {
  let response = await api.get(`/user/accept/${userId}`);

  return response.data;
};
